import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useAppSelector } from "hooks";
import CommonLoader from "components/CommonLoader";

function NsoRequest({ id }: { id: string }) {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const nsoSelector = useAppSelector((state) => state.nsoFlow.nsoFlow.data[0].data);
  const nsoSelectorLoading = useAppSelector((state) => state.nsoFlow.nsoFlow.loading);

  // const [responseDataData] = React.useState<any>(nsoSelector.response_json);
  useEffect(() => {
    // console.log("requestData", nsoSelector);
  }, [id, nsoSelector]);
  const data: Array<any> = [
    {
      id: 1,
      name: "Request Id",
      value: nsoSelector?.request_json?.requestId ?? "",
    },
    {
      id: 2,
      name: "RTO Id",
      value: nsoSelector?.request_json?.RTOId ?? "",
    },
    {
      id: 3,
      name: "URN",
      value: nsoSelector?.request_json?.urn ?? "",
    },
    {
      id: 4,
      name: "Dealer Code",
      value: nsoSelector?.request_json?.dealerCode ?? "",
    },
    {
      id: 5,
      name: "Exterior Color",
      value: nsoSelector?.request_json?.exteriorColor ?? "",
    },
    {
      id: 6,
      name: "Interior Color",
      value: nsoSelector?.request_json?.interiorColor ?? "",
    },
    {
      id: 7,
      name: "Model No",
      value: nsoSelector?.request_json?.modelNo ?? "",
    },
    {
      id: 8,
      name: "Model Year",
      value: nsoSelector?.request_json?.modelYear ?? "",
    },
    {
      id: 9,
      name: "PPO Options",
      value: nsoSelector?.request_json?.ppoOptions ?? "",
    },
    {
      id: 10,
      name: "Region Code",
      value: nsoSelector?.request_json?.regionCode ?? "",
    },
    {
      id: 11,
      name: "Sold Order No",
      value: nsoSelector?.request_json?.soldOrderNo ?? "",
    },
    {
      id: 12,
      name: "User Id",
      value: nsoSelector?.request_json?.userId ?? "",
    },
  ];

  return (
    <>
      {nsoSelectorLoading ? (
        <CommonLoader active={nsoSelectorLoading} />
      ) : (
        <div className="border border-gray-300 rounded-lg shadow-lg">
          <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
            <div className="flex w-full justify-start items-center content-center">
              <span className="font-bold mx-4 text-xl">NSO Request Details</span>
            </div>
            <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 m-4 gap-4">
              {data.map((item) => (
                <div className="grid grid-cols-2" key={item.id}>
                  <div>
                    <span className="text-sm">{item.name}</span>
                  </div>
                  <div>
                    <span className="text-sm whitespace-pre-wrap break-words">{item.value}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

NsoRequest.propTypes = {
  requestData: PropTypes.any,
  responseData: PropTypes.any,
};

export default NsoRequest;
